// extracted by mini-css-extract-plugin
export var center = "_1q-2";
export var clickableRow = "_1q-5";
export var expandedRow = "_1q-7";
export var hoverable = "_1q-4";
export var left = "_1q-1";
export var right = "_1q-3";
export var row = "_1q-0";
export var selectedRow = "_1q-6";
export var summaryRow = "_1q-8";